import { TRequestorToFillLAT1Form } from '../models'

export const getInitialFormData = (): TRequestorToFillLAT1Form => ({
  AdditionalComments: '',
  BuyerType: '',
  Exhibits: '',
  HPContractAdminLocation: '',
  PartnerTerritoryISO: [],
  SpecialPrograms: [],
})
